import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, IconButton, useMediaQuery } from '@mui/material';
import { RootState } from '../store/store';
import { useTranslation } from 'react-i18next';
import InfoIcon from '@mui/icons-material/Info';

const AttributionBox: React.FC = () => {
  const position = useSelector((state: RootState) => state.map);
  const { t } = useTranslation();
  const openStreetMapUrl = `https://www.openstreetmap.org/fixthemap?lat=${position.latitude}&lon=${position.longitude}`;

  const isMobile = useMediaQuery('(max-width:600px)');
  const [isExpanded, setIsExpanded] = useState(false);

  return isMobile && !isExpanded ? (
    <IconButton
      sx={{
        position: 'absolute',
        bottom: '8px',
        right: '8px',
        borderRadius: '50%',
        padding: '2px',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        boxShadow: 2,
      }}
      onClick={() => {
        setIsExpanded(!isExpanded);
      }}
    >
      <InfoIcon />
    </IconButton>
  ) : (
    <Box
      sx={{
        position: 'absolute',
        bottom: '8px',
        right: '8px',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        pl: 1,
        pr: 1,
        pt: 0.5,
        pb: 0.5,
        borderRadius: '12px',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box display={isMobile && !isExpanded ? 'none' : 'flex'}>
        <Typography
          component="a"
          href="https://www.openstreetmap.org/copyright"
          sx={{
            margin: '0px',
            textDecoration: 'none',
            fontSize: '0.875rem',
            color: 'black',
          }}
        >
          {t('attributions.OSM')}
        </Typography>

        <Typography
          component="span"
          sx={{ margin: '0 8px', fontSize: '0.875rem' }}
        >
          |
        </Typography>

        <Typography
          id={'map-style'}
          component="a"
          href="https://www.maptiler.com/copyright/"
          sx={{
            margin: '0px',
            textDecoration: 'none',
            fontSize: '0.875rem',
            color: 'black',
          }}
        >
          © MapTiler
        </Typography>

        <Typography
          component="span"
          sx={{ margin: '0 8px', fontSize: '0.875rem' }}
        >
          |
        </Typography>
        <Typography
          component="a"
          href={openStreetMapUrl}
          sx={{
            margin: '0px',
            textDecoration: 'none',
            fontSize: '0.875rem',
            color: 'black',
          }}
        >
          {t('attributions.fixTheMap')}
        </Typography>
        {isMobile && (
          <IconButton
            sx={{
              borderRadius: '50%',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              padding: '0',
            }}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <InfoIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default AttributionBox;
